import { render, staticRenderFns } from "./OrderRequestList.vue?vue&type=template&id=743b72f5&scoped=true"
import script from "./OrderRequestList.vue?vue&type=script&lang=js"
export * from "./OrderRequestList.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestList.vue?vue&type=style&index=0&id=743b72f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743b72f5",
  null
  
)

export default component.exports